module.exports = __webpack_public_path__ + "img/Title_Text.3850ca62.png";